import React, {useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {useIsDrawerMode} from '../../util/Ares/customHooks';
import {useUserPreferences} from '../../util/customHooks';
import './index.scss';
import '@ey/motif-react-wrapper/ey-asu-motif.css';
import '@ey/styled-theme/styles.css';
import './main.less';
import classnames from 'classnames';

export default function Main({isMFE, children}) {
	const features = useSelector((store) => store.configurations?.features);

	const appVersionState = useSelector((store) => store.appVersion);

	const location = useLocation();

	const matchesPath = useMemo(() => {
		const paths = ['/guidedworkflow', '/guidedworkflowv2', '/fit', '/standalone', '/drydock'];

		const currentPath = window.location.pathname.toLowerCase();

		return paths.some((path) => currentPath.startsWith(path));
	}, []);

	useEffect(() => {
		if (appVersionState.upgrade) {
			localStorage.setItem('app.version', appVersionState.version);
			window.location.reload();
		}
	}, [appVersionState]);

	const [hasLeftSection, setHasLeftSection] = useState(false);

	useEffect(() => {
		setHasLeftSection(document.documentElement.classList.contains('leftSideSection'));
	}, []);

	const mainClasses = classnames('main', 'key', {
		training: features?.isTrainingEnvironment
	});

	const containerClasses = classnames('MainContainerWrapper', {
		'left-margin': !matchesPath && !hasLeftSection
	});

	return (
		<section className={mainClasses}>
			<MainContainerWrapper className={containerClasses}>{children}</MainContainerWrapper>
		</section>
	);
}

const MainContainerWrapper = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1 1 0;
	overflow-x: hidden;
	max-width: 100%;
	&.left-margin {
		margin-left: var(--px-390);
	}
	&:has(.cookie-settings) {
		margin-left: 0;
	}
	.StyledBlockingLoader {
		& + * {
			opacity: 0.1;
			pointer-events: none;
		}
	}
`;
